// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatMessages-chatMessageBox-zooOF {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    border: 1px solid var(--primary-border);
    background: var(--primary-input-bg);
    border-radius: 100px;
    padding: 8px 8px 8px 24px;
    gap: 6px;
    grid-gap: 6px;
}


.ChatMessages-chatMessageInputContainer-xUMHF {
    position: relative;
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
    z-index: 1;
}


.ChatMessages-chatMessageInput-JqU6O {
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    min-height: 26px;
    max-height: 70px;
    white-space: pre-wrap;
    word-break: break-word;
    overflow-y: auto;
    overflow-x: hidden;
    text-align: start;
    color: var(--primary-foreground);
    padding-right: 6px;
}


.ChatMessages-chatMessageInput-JqU6O:focus,
.ChatMessages-chatMessageInput-JqU6O:active {
    -webkit-box-shadow: unset;
            box-shadow: unset;
    outline: unset;
}


.ChatMessages-chatMessageInput-JqU6O:focus-visible {
    -webkit-box-shadow: unset;
            box-shadow: unset;
    outline: unset;
}


.ChatMessages-chatTextAreaPlaceholder-b9TQH {
    position: absolute;
    top: 50%;
    left: 0;
    -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
            transform: translateY(-50%);
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    z-index: -1;
    color: var(--primary-placeholder-foreground);
}


.ChatMessages-chatMessageSendIconContainer-iGVtb {
    position: relative;
    width: 52px;
    height: 52px;
    border-radius: 50%;
    background: var(--primary-bg);
    -webkit-box-shadow: 0px 4px 10px 0px #D32F2F24;
            box-shadow: 0px 4px 10px 0px #D32F2F24;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    -ms-flex-negative: 0;
        flex-shrink: 0;
    cursor: pointer;
}


.ChatMessages-chatMessageSendIconContainer-iGVtb img {
    width: 28px;
    height: 28px;
}


@media (max-width: 767px) {
    .ChatMessages-chatMessageBox-zooOF {
        padding: 8px 8px 8px 18px;
    }

    .ChatMessages-chatMessageInput-JqU6O {
        max-height: 48px;
    }

    .ChatMessages-chatMessageSendIconContainer-iGVtb {
        width: 42px;
        height: 42px;
    }

    .ChatMessages-chatMessageSendIconContainer-iGVtb img {
        width: 18px;
        height: 18px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/ChatMessages/ChatMessages.css"],"names":[],"mappings":"AAAA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,uCAAuC;IACvC,mCAAmC;IACnC,oBAAoB;IACpB,yBAAyB;IACzB,QAAQ;IACR,aAAa;AACjB;;;AAGA;IACI,kBAAkB;IAClB,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;IACZ,UAAU;AACd;;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,gCAAgC;IAChC,kBAAkB;AACtB;;;AAEA;;IAEI,yBAAiB;YAAjB,iBAAiB;IACjB,cAAc;AAClB;;;AAEA;IACI,yBAAiB;YAAjB,iBAAiB;IACjB,cAAc;AAClB;;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,mCAA2B;QAA3B,+BAA2B;YAA3B,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,4CAA4C;AAChD;;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,8CAAsC;YAAtC,sCAAsC;IACtC,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,oBAAc;QAAd,cAAc;IACd,eAAe;AACnB;;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;;AAEA;IACI;QACI,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ","sourcesContent":[".chatMessageBox {\n    display: flex;\n    align-items: center;\n    border: 1px solid var(--primary-border);\n    background: var(--primary-input-bg);\n    border-radius: 100px;\n    padding: 8px 8px 8px 24px;\n    gap: 6px;\n    grid-gap: 6px;\n}\n\n\n.chatMessageInputContainer {\n    position: relative;\n    flex-grow: 1;\n    z-index: 1;\n}\n\n.chatMessageInput {\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 26px;\n    min-height: 26px;\n    max-height: 70px;\n    white-space: pre-wrap;\n    word-break: break-word;\n    overflow-y: auto;\n    overflow-x: hidden;\n    text-align: start;\n    color: var(--primary-foreground);\n    padding-right: 6px;\n}\n\n.chatMessageInput:focus,\n.chatMessageInput:active {\n    box-shadow: unset;\n    outline: unset;\n}\n\n.chatMessageInput:focus-visible {\n    box-shadow: unset;\n    outline: unset;\n}\n\n.chatTextAreaPlaceholder {\n    position: absolute;\n    top: 50%;\n    left: 0;\n    transform: translateY(-50%);\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 26px;\n    z-index: -1;\n    color: var(--primary-placeholder-foreground);\n}\n\n.chatMessageSendIconContainer {\n    position: relative;\n    width: 52px;\n    height: 52px;\n    border-radius: 50%;\n    background: var(--primary-bg);\n    box-shadow: 0px 4px 10px 0px #D32F2F24;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    cursor: pointer;\n}\n\n.chatMessageSendIconContainer img {\n    width: 28px;\n    height: 28px;\n}\n\n@media (max-width: 767px) {\n    .chatMessageBox {\n        padding: 8px 8px 8px 18px;\n    }\n\n    .chatMessageInput {\n        max-height: 48px;\n    }\n\n    .chatMessageSendIconContainer {\n        width: 42px;\n        height: 42px;\n    }\n\n    .chatMessageSendIconContainer img {\n        width: 18px;\n        height: 18px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chatMessageBox": `ChatMessages-chatMessageBox-zooOF`,
	"chatMessageInputContainer": `ChatMessages-chatMessageInputContainer-xUMHF`,
	"chatMessageInput": `ChatMessages-chatMessageInput-JqU6O`,
	"chatTextAreaPlaceholder": `ChatMessages-chatTextAreaPlaceholder-b9TQH`,
	"chatMessageSendIconContainer": `ChatMessages-chatMessageSendIconContainer-iGVtb`
};
module.exports = ___CSS_LOADER_EXPORT___;
